<template>
  <div class="flex flex-wrap">
    <div class="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center">
      <main-card
        title="Software-Lösungen für Ihre Bedürfnisse"
        subtitle="Wir setzen Ihre Idee als digitale, innovative Lösung um. Gerne helfen wir auch Ihre Prozesse zu digitalisieren."
        icon="fa fa-desktop"
        scrollTo="#development_section"
      ></main-card>
    </div>
    <div class="w-full md:w-4/12 px-4 text-center">
      <main-card
        title="Cloud Consulting"
        subtitle="Gerne beraten wir Sie bei der Auswahl und Umsetzung der geeigneten Cloud-Strategie Ihres Unternehmens."
        icon="fas fa-cloud"
        scrollTo="#cloud_section"
      ></main-card>
    </div>
    <div class="pt-6 w-full md:w-4/12 px-4 text-center">
      <main-card
        title="Verstärken Sie Ihr Team"
        subtitle="Unsere Engineers verstärken bei Bedarf Ihre eigene Entwicklung und ermöglicht Ihnen so bei Engpässen eine einfache und bedarfsgerechte Skalierung Ihres Teams."
        icon="fa fa-user-friends"
        scrollTo="#external_section"
      ></main-card>
    </div>
  </div>
</template>

<script>
import MainCard from "../components/Base/MainCard.vue";
export default {
    components: {
        MainCard
    }
};
</script>

<style>
</style>